var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"loader",staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin loader"})])}
var staticRenderFns = []

export { render, staticRenderFns }